import { render } from "./Manuals.vue?vue&type=template&id=0ee104b8&scoped=true"
import script from "./Manuals.vue?vue&type=script&lang=js"
export * from "./Manuals.vue?vue&type=script&lang=js"

import "./Manuals.vue?vue&type=style&index=0&id=0ee104b8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee104b8"]])

export default __exports__